module.exports = __webpack_public_path__ + "static/media/trøytt.2cd2c89a.m4a";